export function getUserIdFromJwt(token: string): string | null {
  try {
    const [, payload] = token.split(".");
    if (!payload) return null;
    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
    const json = JSON.parse(atob(normalized));
    return typeof json.sub === "string" ? json.sub : null;
  } catch {
    return null;
  }
}
